import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { stopImpersonation } from '../../store/auth/actions';

const ImpersonationBanner = () => {
  const dispatch = useDispatch();
  const isImpersonating = useSelector((state) => state.Auth.isImpersonating);
  const impersonatedUser = useSelector((state) => state.Auth.admin);
  const originalAdmin = useSelector((state) => state.Auth.originalAdmin);

  const handleStopImpersonation = () => {
    dispatch(stopImpersonation());
  };

  if (!isImpersonating) {
    return null;
  }

  return (
    <div
      className="alert alert-warning mb-0"
      style={{
        borderRadius: 0,
        borderLeft: 'none',
        borderRight: 'none',
        borderTop: 'none',
        marginBottom: 0,
        padding: '6px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
      }}>
      <div
        className="d-flex align-items-center"
        style={{ minWidth: 0, flex: '1 1 auto' }}>
        <i
          className="bx bx-user-circle font-size-18 mr-2"
          style={{ flexShrink: 0 }}></i>
        <span
          className="font-size-13"
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}>
          Viewing as <strong>{impersonatedUser?.displayName}</strong>
          {impersonatedUser?.role && (
            <span
              className="badge badge-secondary ml-2"
              style={{ fontSize: '11px' }}>
              {impersonatedUser.role}
            </span>
          )}
        </span>
      </div>
      <button
        type="button"
        className="btn btn-sm btn-danger waves-effect waves-light"
        onClick={handleStopImpersonation}
        style={{
          padding: '2px 10px',
          fontSize: '12px',
          marginLeft: '10px',
          flexShrink: 0,
        }}>
        <i className="bx bx-x"></i> Exit
      </button>
    </div>
  );
};

export default ImpersonationBanner;
